module.exports = __webpack_public_path__ + "img/consult_info1.5be366ff.png";